import appModule from './app.module.js';

export default appModule;
